/**
 * Global phone validation for contact / emergency config.
 * Supports international numbers (+...), national numbers, and short emergency/service numbers.
 * Keep in sync with op-dox-backend/src/app/utils/worldwide-phone.ts
 */
export function isValidWorldwidePhoneNumber(input) {
  if (!input || typeof input !== "string") return false;
  const trimmed = input.trim();
  if (!trimmed) return false;

  // Allow digits, spaces, +, -, (, ) only
  if (!/^[+\d\s\-()]+$/.test(trimmed)) return false;

  // + can only appear once and only at start
  const plusCount = (trimmed.match(/\+/g) || []).length;
  if (plusCount > 1 || (plusCount === 1 && !trimmed.startsWith("+"))) return false;

  const digits = trimmed.replace(/\D/g, "");
  if (!digits.length) return false;

  // Emergency/service short codes (2-6 digits)
  if (digits.length >= 2 && digits.length <= 6) return true;

  // Standard international max length is 15 digits (E.164)
  return digits.length >= 7 && digits.length <= 15;
}

export const WORLDWIDE_PHONE_INVALID_MESSAGE =
  "Enter a valid phone number (landline, mobile, or emergency/service number).";

/** @returns {string|null} Error message or null if empty (optional field) or valid */
export function validateWorldwideContactNumber(phoneNumber) {
  if (!phoneNumber || String(phoneNumber).trim() === "") {
    return null;
  }
  if (!isValidWorldwidePhoneNumber(phoneNumber)) {
    return WORLDWIDE_PHONE_INVALID_MESSAGE;
  }
  return null;
}
